export default "__VITE_ASSET__C0uTApwI__"